import { useMutation } from '@tanstack/react-query'
import { TypeSignupApplication } from './useSignUpApplication'
import { post, queryKeys, SignUpUrl } from '@mobi/account/Utils'
import { TypeVerificationResponse } from './useVerifyDriversLicence'

export type TypePassportDetailsRequest = TypeSignupApplication & {
  passportDetails: {
    number: string
    passportCountry: string
  }
}

export const useVerifyPassport = () => {
  const { mutate: verifyPassport, status: verifyPassportStatus } = useMutation({
    mutationFn: (passportDetails: TypePassportDetailsRequest): Promise<TypeVerificationResponse> =>
      post(SignUpUrl.verifyPassport, passportDetails),
    mutationKey: [queryKeys.signupVerifyPassport],
  })
  return { verifyPassport, verifyPassportStatus }
}
